export default "__VITE_ASSET__8182045d__"